import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS } from '../../utils/handler';
import { USER_AUTH } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { POST, GET } = HTTP_METHODS;
const { USER_LOGIN, OTP_VERIFY, IS_LOGIN, IS_LOGOUT, GOOGLE_SSO } = USER_AUTH;

export const userAuthApi = createApi({
  reducerPath: 'userAuth',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: USER_LOGIN,
        method: POST,
        data: credentials
      })
    }),
    otpVerify: builder.mutation({
      query: (credentials) => ({
        url: OTP_VERIFY,
        method: POST,
        data: credentials
      })
    }),
    isLoggedIn: builder.query({
      query: (credentials) => ({
        url: IS_LOGIN,
        method: GET,
        data: credentials
      })
    }),
    isGoogleSSO: builder.mutation({
      query: (credentials) => ({
        url: GOOGLE_SSO,
        method: POST,
        data: credentials
      })
    }),
    userLogOut: builder.mutation({
      query: () => ({
        url: IS_LOGOUT,
        method: GET
      })
    })
  })
});

export const {
  useLoginMutation,
  useOtpVerifyMutation,
  useIsLoggedInQuery,
  useUserLogOutMutation,
  useIsGoogleSSOMutation
} = userAuthApi;
